import './modal-pedidos.css';
import { Button, Col, Row } from 'react-materialize';

import React , { useState } from 'react';
import Swal from 'sweetalert2';


function ModalPedidosItem(props) {
  let items = props.items;
  const user = JSON.parse(localStorage.getItem('user'));
  const cancelAuth = user.orderCanc;
  const salesPersonId = user.salesPersonId;
  const [hideRemissionButton, setHideRemissionButton] = useState(false);

  const handleManualUpdate = () => {
    setHideRemissionButton(true);

    setTimeout(() => {
      setHideRemissionButton(false);
    }, 5000);
  };

  return (
    <React.Fragment>
      {items.map((item, index) => {
        console.log(item);
        return (
          <React.Fragment key={item.salesOrderId}>
            <div className="containerPedidoItem">
              <Row>
                <Col s={7} m={7} l={7} xl={7}>
                  <p>
                    <strong># Turno:</strong> {item?.turn ?? props.turn ?? '—'}
                  </p>

                  <p>
                    <strong># Pedido:</strong> {item.salesOrderId}
                  </p>
                  <p>
                    <strong># Remisión:</strong> {item.remisionId}
                  </p>

                  <p>
                    <strong>Estatus:</strong> {item.status}
                  </p>
                  <p>
                    <strong>Cliente:</strong> {item.customer ? item.customer : ''}
                  </p>
                  <p>
                    <strong>Total: </strong> $
                    {parseFloat(item.total).toFixed(2)}
                  </p>
                </Col>

                <Col s={5} m={5} l={5} xl={5}>
                  <p>
                    <strong># Factura:</strong> {item.invoiceId}
                  </p>
                  <p>
                    <strong>Fecha pedido:</strong> {item.orderDate}
                  </p>
                  <p>
                    <strong>Hora pedido:</strong> {item.orderHour}
                  </p>
                  <p>
                    <strong>Vendedor:</strong>{' '}
                    {item.salesPerson ? item.salesPerson : null}
                  </p>
                  <p>
                    <strong>Sub Total: </strong> $
                    {parseFloat(item.subTotal).toFixed(2)}
                    &nbsp;&nbsp;&nbsp; <strong>IVA: </strong>${item.IVA}
                  </p>
                </Col>
              </Row>

              <Row>
                <Col s={12} m={12} l={12} xl={12} align="center">
                  {(cancelAuth === "1" || item.salesPersonId === salesPersonId) &&
                    (item.remisionId === "" || item.invoiceId !== "" ? null : (
                      <Button
                        node="button"
                        waves="light"
                        style={{ margin: '0 1%' }}
                        onClick={() => {
                          Swal.fire({
                            title: '¿Estas seguro?',
                            text: 'Vas a cancelar el pedido..',
                            icon: 'warning',
                            reverseButtons: true,
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            cancelButtonText: 'Salir',
                            confirmButtonText: 'Si, Cancelar',
                          }).then(async (result) => {
                            if (result.value) {
                              let resultCancel = await props.onCancel();
                              if (resultCancel) {
                                Swal.fire(
                                  'Cancelado!',
                                  'Pedido cancelado.',
                                  'success'
                                );
                              }
                            }
                          });
                        }}
                      >
                        Cancelar pedido
                      </Button>
                    ))}

                  <Button
                    node="button"
                    waves="light"
                    style={{ margin: '0 1%' }}
                    onClick={() => {
                      const turnFromItem =
                        item && typeof item.turn !== 'undefined' ? item.turn : null;
                      const turnToPrint =
                        turnFromItem !== null && turnFromItem !== ''
                          ? turnFromItem
                          : props.turn;

                      const orderKey = String(item?.salesOrderId || '').trim().toUpperCase();

                      try {
                        window.__TURN__ = turnToPrint;
                        window.__PRINT_ORDER_KEY__ = orderKey;
                      } catch (_) {}

                      if (typeof props.print === 'function') {
                        props.print(turnToPrint, orderKey, item);
                      }
                    }}
                  >
                    Imprimir
                  </Button>

                  {!hideRemissionButton &&
                    !(item.remisionId !== '' || item.status === 'Cancelado') && (
                      <Button
                        node="button"
                        waves="light"
                        style={{ margin: "0 1%" }}
                        onClick={() => {
                          props.makeRemission(item.salesOrderId);
                          handleManualUpdate();
                        }}
                      >
                        Crear Remisión
                      </Button>
                    )}

                  <Button
                    node="button"
                    waves="light"
                    style={{ margin: '0 1%' }}
                    onClick={() => {
                      props.showSendMail();
                    }}
                  >
                    Enviar mail
                  </Button>

                  <Button
                    node="button"
                    waves="light"
                    style={{ margin: '0 1%' }}
                    onClick={() => {
                      props.handleClickCopy();
                    }}
                  >
                    Enviar por Whatsapp
                  </Button>

                  <Button
                    node="button"
                    waves="light"
                    style={{ margin: '0 1%' }}
                    onClick={() => {
                      props.edit();
                    }}
                  >
                    {!props.inEdition ? 'Modificar' : 'Cerrar'}
                  </Button>
                </Col>
              </Row>
            </div>
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
}

export { ModalPedidosItem as default };